import { findAvailableSlot, openSlot } from './utils';
import * as store from './slotOpenerStore';

import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef, Point } from 'types/documentServices';

const LINE_MARGIN = 8;

export function showSlotIfExists(editorAPI: EditorAPI, mousePosition: Point) {
  const slot = findAvailableSlot(
    store.getAllSlotsInContainer(),
    mousePosition.y,
  );

  store.setAvailableSlot(slot);

  if (!slot) {
    return;
  }

  const y = slot.layoutY.y + slot.layoutY.height / 2;
  const x1 = editorAPI.site.getSiteX() + LINE_MARGIN;
  const x2 =
    editorAPI.site.getSiteX() + editorAPI.site.getWidth() - LINE_MARGIN;

  editorAPI.snapData.set(
    [
      ...(editorAPI.store.getState().snapData ?? []),
      {
        type: 'slotOpenerLine',
        line: [
          { x: x1, y },
          { x: x2, y },
        ],
        rectanglesDrawData: [],
      },
    ],
    true,
  );
}

export function openSlotIfExists(
  editorAPI: EditorAPI,
  comp: CompRef | CompRef[],
) {
  store.setAllSlotsInContainer([]);
  const availableSlot = store.getAvailableSlot();
  if (availableSlot) {
    openSlot(editorAPI, comp, availableSlot);
  }
  store.setAvailableSlot(null);
}
